import { Orion, SupportedChainId, Unit } from '@orionprotocol/sdk';
import { createContext, useContext } from 'react';

type LumiaContext = {
  availableUnits: Partial<Record<SupportedChainId, Unit>>;
  activeUnit: Unit | undefined;
  lumia: Orion | undefined;
};

export const LumiaContext = createContext<LumiaContext>({
  availableUnits: {},
  activeUnit: undefined,
  lumia: undefined,
});

export const useLumia = (): LumiaContext => useContext(LumiaContext);
